const APP_DEPLOYMENT_BASE_URL = process.env.REACT_APP_DEPLOYMENT_DOMAIN;

// helper functions

export const isStringEmpty = (str) => {
  return str.trim() === "";
};

export const isArrayEmpty = (arr) => {
  return Object.keys(arr).length === 0;
};

export const isResponseInvalid = (questions) => {
  return questions.some((question) => {
    switch (typeof question.answer) {
      case "string":
        return isStringEmpty(question.answer);

      case "object":
        return isArrayEmpty(question.answer);

      default:
        return false;
    }
  });
};

export const nameToKey = (name) => {
  return name.split(" ").join("_");
};

export const formatTitle = (text, charsToKeep = 40) => {
  return text.substring(0, charsToKeep);
};

export const getFormUrl = (formId) => {
  return `${APP_DEPLOYMENT_BASE_URL}/viewForm/${formId}`;
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

export const downloadResponses = (responses, title) => {
  var csv = "";
  responses.forEach((row) => {
    row.forEach((cell) => {
      // enclosing string with double quotes to escape comma in csv
      // eslint-disable-next-line
      csv = csv + '"' + cell + '"' + ",";
    });

    csv += "\n";
  });

  var hiddenElement = document.createElement("a");
  hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
  hiddenElement.target = "_blank";
  hiddenElement.download = `${title}.csv`;
  hiddenElement.click();
};
